import React, { createContext, useState, useContext } from 'react';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import {
  onLoadInformationAPI,
  GetOrderStatusAPI,
  UrlValidationAPI,
} from './../context-api/api-services/onloadinfo';
import { publicIp, publicIpv4, publicIpv6 } from 'public-ip';
import { getUrlParams, getUrlPath, getUrlFullPath, removeParamFromUrl } from './../global/getUrl';
import { localStorageKeys } from './../global/constants';

export const GlobalStateDataContext = createContext();
const GlobalStateDataProvider = ({ children }) => {
  const { REFRESH_TOKEN, TOKEN } = localStorageKeys;
  const hasTokens = localStorage.getItem(TOKEN);

  const { MANAGING_BRANCH_NAME } = localStorageKeys;
  const [onLoadInfoResponse, setOnLoadInfoResponse] = useState({
    loading: false,
    success: null,
    message: null,
    data: null,
  });
  const [orderStatusResponse, setOrderStatusResponse] = useState({
    loading: false,
    success: null,
    message: null,
    data: null,
  });

  const [urlValidationResponse, setUrlValidationResponse] = useState({
    loading: false,
    success: false,
    message: null,
    data: null,
  });

  const [urlPromoCode, setUrlPromoCode] = useState(undefined);
  const [urlInflueCode, setUrlInflueCode] = useState(undefined);
  const [redirectedUrlInfo, setRedirectedUrlInfo] = useState('');

  const [openLiveOrderTracking, setOpenLiveOrderTracking] = useState(false);

  const [publicIp, setPublicIp] = useState(null);
  const urlParamsObject = () => getUrlParams();
  const urlReferralNo = urlParamsObject().referral; // when you get that referral set in localstorage ,
  const localStorageManagingBranch = () => localStorage.getItem(MANAGING_BRANCH_NAME);
  const [expoMobileData, setExpoMobileData] = useState(null); // Getting data from Expo React Native

  const OnLoadInformation = async () => {
    let EmailAddress = null;
    if (hasTokens) {
      const decodedToken = jwt_decode(hasTokens);
      const { email } = decodedToken || null;
      EmailAddress = email;
    }

    const payloadData = {
      public_ip: await publicIpv4(),
      url_full_path: getUrlFullPath(),
      referral: urlReferralNo,
      branchName: localStorageManagingBranch(),
      custEmail: EmailAddress,
    };

    try {
      await setOnLoadInfoResponse({
        loading: true,
        success: null,
        message: null,
        data: null,
      });

      const data = await onLoadInformationAPI(payloadData);
      // console.log('onload API', data)

      if (data.hasError) {
        await setOnLoadInfoResponse({
          loading: false,
          data: null,
          success: !data.hasError,
          message: data.message,
        });
        return data;
      }

      if (data.data?.success) {
        await setOnLoadInfoResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          message: data.data?.message,
        });
        const Data = data?.data?.data;
        if (
          Data?.total_meal_ordres !== 0 ||
          Data?.total_payasyougo_ordres !== 0 ||
          Data?.total_promotional_orders !== 0
        ) {
          setOpenLiveOrderTracking(true);
        }
      } else {
        await setOnLoadInfoResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          // message: data.data?.errors[0]?.CustomMessage || data.data?.CustomMessage,
          message: data.data?.CustomMessage || 'Backend Validation errors',
        });
      }
      return data;
    } catch (error) {
      console.log('---Catch black OnLoadInformation', error);
      setOnLoadInfoResponse({ loading: false, data: null, success: false, message: error });
    }
  };

  const GetOrderStatus = async (payload) => {
    try {
      if (hasTokens) {
        axios.defaults.headers.common.Authorization = `Bearer ${hasTokens}`;
      } else {
        setOrderStatusResponse({
          loading: false,
          data: null,
          success: false,
          errorMessage: 'Token & Refresh Token missing',
        });
        return;
      }

      await setOrderStatusResponse({
        loading: true,
        success: null,
        message: null,
        data: null,
      });

      const data = await GetOrderStatusAPI(payload);

      if (data?.hasError) {
        await setOrderStatusResponse({
          loading: false,
          data: null,
          success: !data.hasError,
          message: data.message,
        });
        return;
      }

      if (data?.data?.success) {
        await setOrderStatusResponse({
          loading: false,
          data: data,
          success: data?.data?.success,
          message: data?.data?.message,
        });
        return data;
      } else {
        await setOrderStatusResponse({
          loading: false,
          data: data,
          success: data?.data?.success,
          message: data?.data?.message,
        });
        return data;
      }
    } catch (error) {
      console.log('---Catch black GetOrderStatus', error);
      setOrderStatusResponse({ loading: false, data: null, success: false, message: error });
    }
  };

  const ValidateUrl = async (payload) => {
    const payloadData = {
      zipcode: payload?.zipcode,
      promoUrlCode: payload?.promoUrlCode,
      managing_branch_name: localStorageManagingBranch(),
      promo_status: true,
    };

    try {
      await setUrlValidationResponse({
        loading: true,
        success: false,
        message: null,
        data: null,
      });

      const data = await UrlValidationAPI(payloadData);

      if (data.hasError) {
        await setUrlValidationResponse({
          loading: false,
          data: null,
          success: !data.hasError,
          message: data.message,
        });
        return data;
      }

      if (data.data?.success) {
        await setUrlValidationResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          message: data.data?.message,
        });
      } else {
        await setUrlValidationResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          // message: data.data?.errors[0]?.CustomMessage || data.data?.CustomMessage,
          message: data.data?.CustomMessage || 'Backend Validation errors',
        });
      }
      return data;
    } catch (error) {
      console.log('---Catch black ValidateUrl', error);
      setUrlValidationResponse({ loading: false, data: null, success: false, message: error });
    }
  };

  return (
    <GlobalStateDataContext.Provider
      value={{
        OnLoadInformation,
        onLoadInfoResponse,
        setOnLoadInfoResponse,
        openLiveOrderTracking,
        setOpenLiveOrderTracking,
        GetOrderStatus,
        orderStatusResponse,
        setOrderStatusResponse,
        urlPromoCode,
        setUrlPromoCode,
        urlInflueCode,
        setUrlInflueCode,
        redirectedUrlInfo,
        setRedirectedUrlInfo,
        ValidateUrl,
        urlValidationResponse,
        setUrlValidationResponse,
        expoMobileData,
        setExpoMobileData,
      }}
    >
      {children}
    </GlobalStateDataContext.Provider>
  );
};

export default GlobalStateDataProvider;
